import React from 'react'
import { AmountField, ErrorMessage, RecurringSelection } from '.'

export const AmountAndRecurringSelection = (): JSX.Element => {
  return (
    <div className="donations-form-amount-selection">
      <h4 className="amount-headline">{i18n.t('donate.attributes.amount')}</h4>
      <div className="amount-wrapper desktop:mb-3">
        <div className="amount-input-wrapper">
          <AmountField hideError />
        </div>
      </div>
      <div className="donations-form-recurring-selection">
        <RecurringSelection />
      </div>
      <div className="amount-error">
        <ErrorMessage field="amount_cents" />
      </div>
    </div>
  )
}
